import { render, staticRenderFns } from "./orderconfirm.vue?vue&type=template&id=2437f7a4&scoped=true&"
import script from "./orderconfirm.vue?vue&type=script&lang=js&"
export * from "./orderconfirm.vue?vue&type=script&lang=js&"
import style0 from "./orderconfirm.vue?vue&type=style&index=0&id=2437f7a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2437f7a4",
  null
  
)

export default component.exports